import { useTranslation } from 'react-i18next';
import ArticleLayout from '@/components/ArticleLayout';

export default function CategoriesPage() {
  const { t } = useTranslation('home');

  const categories = [
    { label: 'cat_shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', desc: 'Sneakers, running shoes, boots, and casual footwear.' },
    { label: 'cat_hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', desc: 'Hoodies, sweaters, and pullovers.' },
    { label: 'cat_tshirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', desc: 'T-shirts, tank tops, and casual tops.' },
    { label: 'cat_jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', desc: 'Jackets, coats, and outerwear.' },
    { label: 'cat_pants', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', desc: 'Pants, shorts, and jeans.' },
    { label: 'cat_headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', desc: 'Caps, hats, and beanies.' },
    { label: 'cat_sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', desc: 'Matching sets and coordinated outfits.' },
    { label: 'cat_underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', desc: 'Underwear and underpants.' },
    { label: 'cat_jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', desc: 'Sports jerseys and team shirts.' },
    { label: 'cat_accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', desc: 'Jewelry, watches, sunglasses, and small accessories.' },
    { label: 'cat_bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', desc: 'Backpacks, handbags, and crossbody bags.' },
    { label: 'cat_belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', desc: 'Belts and waist accessories.' },
    { label: 'cat_perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', desc: 'Fragrances and colognes.' },
    { label: 'cat_other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', desc: 'Other items and miscellaneous products.' },
  ];

  return (
    <ArticleLayout
      title="CSSBuy Spreadsheet Categories"
      description="Browse CSSBuy product categories including shoes, clothing, accessories, and more."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Categories', to: '/categories' },
      ]}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {categories.map((cat) => (
          <a
            key={cat.label}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group p-5 bg-background-50 border border-background-200 rounded-xl hover:bg-primary-50 hover:border-primary-200 transition-all"
          >
            <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 mb-1">
              {t(cat.label)}
            </h3>
            <p className="text-xs text-foreground-500 leading-relaxed">{cat.desc}</p>
            <div className="mt-3 flex items-center gap-1 text-xs text-primary-700">
              <span>Browse products</span>
              <i className="ri-arrow-right-up-line"></i>
            </div>
          </a>
        ))}
      </div>
    </ArticleLayout>
  );
}